<template>
  <div class="">
    <headerbox></headerbox>

    <div class="main">
      <hotelhead></hotelhead>
      <div class="container">
        <div class="layout">
          <menuTitle :titles="lefttitles"></menuTitle>
          <!-- 优先使用 gaode_lng/gaode_lat，GCJ-02 → BD-09 转换后渲染百度地图 -->
          <template v-if="hotelinfro && ((hotelinfro.gaode_lng && hotelinfro.gaode_lat) || (hotelinfro.baidu_lng && hotelinfro.baidu_lat))">
          <baidu-map
            class="map"
            :center="mapCenter"
            :zoom="18"
            :scroll-wheel-zoom="true"
          >
            <bm-marker
              :position="mapCenter"
              :dragging="true"
              @click="infoWindowOpen"
            >
              <bm-info-window
                :show="show"
                @close="infoWindowClose"
                @open="infoWindowOpen"
              >
                <h3 class="titles">{{ hotelinfro.hotelname }}</h3>
                <p class="address">{{ hotelinfro.address }}</p>
              </bm-info-window>
            </bm-marker>
          </baidu-map></template>
          <div class="reviewsleft"></div>
        </div>

        <div class="sides">
          <menuTitle :titles="righttitles"></menuTitle>
          <leftcheck></leftcheck>
        </div>
      </div>
    </div>
    <footerbox></footerbox>
  </div>
</template>

<script>
import { setStorage, getStorage } from "@/common/until/until";
import footerbox from "components/content/footer";
import headerbox from "components/content/header";
import hotelhead from "components/content/hotelhead";
// import AMapLoader from "@amap/amap-jsapi-loader";
import menuTitle from "components/content/menuTitle";
import leftcheck from "components/content/Leftcheck";
import { getrestapi } from "network/getrestapi";
export default {
  name: "Map",

  components: {
    footerbox,
    headerbox,
    hotelhead,
    leftcheck,
    menuTitle,
  },
  data() {
    return {
      map: null,
      righttitles: "在线酒店查询",
      lefttitles: "酒店地图",
      show: true,
    };
  },
  created() {},

  mounted() {},
  methods: {
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      this.show = true;
    },
    // GCJ-02（高德/谷歌）→ BD-09（百度）坐标系转换
    gcj02ToBd09(lng, lat) {
      const x_PI = (Math.PI * 3000.0) / 180.0;
      const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
      const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
      return {
        lng: z * Math.cos(theta) + 0.0065,
        lat: z * Math.sin(theta) + 0.006,
      };
    },
  }, computed: {
    hotelinfro() {
      // 从Vuex中获取房间信息
      let roomInfo = this.$store.state.hotelinfro;

      // 如果Vuex中没有房间信息，则从LocalStorage中获取
      if (!roomInfo) {
        const localStorageRoomInfo = localStorage.getItem("hoteldata");
        if (localStorageRoomInfo) {
          roomInfo = JSON.parse(localStorageRoomInfo);
        }
      }

      return roomInfo;
    },
    mapCenter() {
      const info = this.hotelinfro;
      if (!info) return { lng: 0, lat: 0 };
      // 优先使用高德坐标（GCJ-02），转为百度 BD-09
      if (info.gaode_lng && info.gaode_lat) {
        return this.gcj02ToBd09(
          parseFloat(info.gaode_lng),
          parseFloat(info.gaode_lat)
        );
      }
      // 降级使用百度坐标
      if (info.baidu_lng && info.baidu_lat) {
        return {
          lng: info.baidu_lng,
          lat: info.baidu_lat,
        };
      }
      return { lng: 0, lat: 0 };
    },
  },
};
</script>

<style  lang="less" scoped>
.map {
  padding: 0px;
  margin: 0px;
  width: 750px;
  height: 600px;
  margin-bottom: 50px;
  .titles{
    line-height: 30px;
  }
  .address {
   color:#999
  }
}

@media (min-width: 320px) and (max-width: 780px) {
  .map{
    width: 100%;
    height:400px;
  }
}
</style>